import styled from "styled-components";

const SupportStyles = styled.div`
  section {
    padding: ${props => props.noPadding ? '0px 5px' : '0px 16px'};
    ${props => props.theme.media.lg} {
      padding: 0px 15%;
    }
  }
`;

export default SupportStyles;